
import { makeProxyRequest } from './api';

const BASE_API = process.env.REACT_APP_API_END_POINT; // Using existing env var as requested

export const getLinkedInAuthUrl = async () => {
    return makeProxyRequest('api/linkedin/auth/url', 'GET');
};

export const handleLinkedInCallback = async (code: string, state: string, userId: string) => {
    const params = new URLSearchParams({ code, state, user_id: userId });
    return makeProxyRequest(`api/linkedin/auth/callback?${params.toString()}`, 'GET');
};

export const getLinkedInTrendingTopics = async () => {
    return makeProxyRequest('api/linkedin/trending', 'GET');
};

export interface LinkedInDraftRequest {
    topic: string;
    tone: string;
    extra_context: string;
}

export const generateLinkedInDraft = async (data: LinkedInDraftRequest) => {
    return makeProxyRequest('api/linkedin/draft', 'POST', data);
};

export interface LinkedInPublishRequest {
    text: string;
}

export const publishToLinkedIn = async (data: LinkedInPublishRequest) => {
    return makeProxyRequest('api/linkedin/publish', 'POST', data);
};
